export function useIsRTL() {
  return document.body.getAttribute("dir") === "rtl";
}
